import builder from '../builder';
import MessagingWhatsapp from '../../streamline-icons/bold/messaging-whatsapp.svg';

export default builder('IconMessagingWhatsappBold', MessagingWhatsapp);
